import React, { useEffect, Suspense } from 'react'
import { Container, Col } from 'react-bootstrap'
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom'
import AnalyticsService from './services/AnalyticsService'
import { createElement } from './services/ElementsService'
import Header from './components/Header'
import Footer from './components/Footer'
import './App.css';

function App() {
  const routes = [
    {
      page: {
        id: 1,
        name: 'Home',
        path: '/',
        components: [
          {
            id: 1,
            name: 'Slider',
            size: 12,
            elements: [
              {
                line: 1,
                content: [
                  {
                    id: 1,
                    size: 12,
                    type: 'carousel',
                    content: [
                      {
                        id: 1,
                        name: '',
                        type: 'image',
                        content: 'https://placehold.co/1200x400'
                      },
                      {
                        id: 2,
                        name: '',
                        type: 'image',
                        content: 'https://placehold.co/1200x400'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            id: 2,
            name: 'News',
            size: 12,
            elements: [
              {
                line: 1,
                content: [
                  {
                    id: 1,
                    size: 6,
                    type: 'image',
                    content: 'https://placehold.co/600x400'
                  },
                  {
                    id: 2,
                    size: 6,
                    type: 'line',
                    content: [
                      {
                        id: 1,
                        size: 12,
                        type: 'image',
                        content: 'https://placehold.co/600x200'
                      },
                      {
                        id: 1,
                        size: 12,
                        type: 'image',
                        content: 'https://placehold.co/600x200'
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            id: 3,
            name: 'Highlights',
            size: 12,
            elements: [
              {
                line: 1,
                content: [
                  {
                    id: 1,
                    size: 4,
                    type: 'text',
                    content: 'Destaque 1'
                  },
                  {
                    id: 2,
                    size: 4,
                    type: 'text',
                    content: 'Destaque 2'
                  },
                  {
                    id: 3,
                    size: 4,
                    type: 'text',
                    content: 'Destaque 3'
                  },
                ]
              }
            ]
          }
        ]
      }
    },
    {
      page: {
        id: 1,
        name: 'Sobre',
        path: '/sobre',
        components: [
          {
            id: 2,
            name: 'Highlights',
            size: 12,
            elements: [
              {
                line: 1,
                content: [
                  {
                    id: 1,
                    size: 12,
                    type: 'text',
                    content: 'Sobre'
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    {
      page: {
        id: 1,
        name: 'Projetos',
        path: '/projetos',
        components: [
          {
            id: 2,
            name: 'Highlights',
            size: 12,
            elements: [
              {
                line: 1,
                content: [
                  {
                    id: 1,
                    size: 4,
                    type: 'text',
                    text: 'Convenções coletivas'
                  }
                ]
              }
            ]
          }
        ]
      }
    },
    {
      page: {
        id: 1,
        name: 'Contato',
        path: '/contato',
        components: [
          {
            id: 2,
            name: 'Highlights',
            size: 12,
            elements: [
              {
                line: 1,
                content: [
                  {
                    id: 1,
                    size: 4,
                    type: 'text',
                    text: 'Contato'
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  ]

  useEffect(() => {
    AnalyticsService.initialize();
  })
  
  return (
    <Router>
      <Routes>
        <Route element={<DefaultLayout />}>
          {routes.map((route) => (
            <Route key={route.page.path} path={route.page.path} element={<DefaultComponent page={route.page} />} />
          ))}
        </Route>
      </Routes>
    </Router>
  );
}

function DefaultComponent({ page }) {
  return (
    <Suspense fallback={<div>Carregando...</div>}>
      {page.components.map((component, index) => {
        return (
          <Col key={index} xs={12} md={12} lg={component.size}>
            {component.elements.map((element, idx) => {
              return (
                <Container>
                  {createElement(element)}
                </Container>
              )
            })}
          </Col>
        )
      })}
    </Suspense>
  )
}

function DefaultLayout() {
  return (
    <>
      <Header />
        <main>
          <Outlet />
        </main>
      <Footer />
    </>
  )
}

export default App;
